import axios from "axios";
import { Toast } from "vant";
import store from "../store";
import common from "./common";
import Bridge from "./dsbridge";
var config = {
  // baseURL:'process.env.BASE_API', // api 的 base_url
  baseURL: "", // 如果没设置域名就执行本地跨域
  timeout: 20000, // request timeout
  withCredentials: false // 访问线上api时axios发送跨域请求时需要设置这个参数
};

if (process.env.NODE_ENV === "development") {
  config.baseURL = process.env.VUE_APP_URL + process.env.VUE_APP_BASE_API; // api 的 base_url
  // 开发环境
} else if (process.env.NODE_ENV === "production") {
  // 生产环境
  config.baseURL = process.env.VUE_APP_URL + process.env.VUE_APP_BASE_API; // 这里是线上api请求地址
}
// create an axios instance
const service = axios.create(config);

// request interceptor
service.interceptors.request.use(
  config => {
    Toast.loading({
      message: "加载中...",
      forbidClick: true,
      duration: 0
    });
    if (store.state.token) {
      // 让每个请求携带token-- ['access_token']为自定义key 请根据实际情况自行修改
      config.headers = {
        Accept: "application/json",
        Authorization: "Bearer " + store.state.token
      };
    }
    return config;
  },
  error => {
    Promise.reject(error);
  }
);

// response interceptor
service.interceptors.response.use(
  response => {
    var succeedMessage = "";
    var typeMessage = "";
    Toast.clear();
    if (response.data !== null && response.data.message) {
      succeedMessage = response.data.message;
      typeMessage = "success";
      Toast[typeMessage](succeedMessage);
    } else if (!response.data) {
      succeedMessage = response.data.message;
      typeMessage = "fail";
      Toast[typeMessage](succeedMessage);
    }

    return response;
  },
  error => {
    let errorMessage = error.response.data.message;
    const errorMsgsList = {
      "Token not provided": "请求头中缺少 Token，跳转登陆中...",
      "A token is required": "请求头中缺少 Token，跳转登陆中...",
      "Token has expired": "Token 过期，跳转登陆中...",
      "Token has expired and can no longer be refreshed":
        "Token 已过期，并且无法再刷新，跳转登陆中...",
      "The token has been blacklisted": "Token 已被拉黑，跳转登陆中...",
      "Token Signature could not be verified.":
        "Token 无法通过签名验证，跳转登陆中..."
    };
    Toast.clear();
    if (error.config.timeout === 5000) {
      errorMessage = "请求超时";
    }
    if (error.response) {
      switch (error.response.status) {
        case 401: {
          Toast["fail"]({
            message: `(${error.response.status})${
              errorMsgsList[errorMessage]
                ? errorMsgsList[errorMessage]
                : errorMessage
            }`,
            duration: 1000,
            onClose: () => {
              const url = window.location.href;
              Bridge.callmethod("refreshToken", {}, function(token) {
                store.state.token = token;
                if (common.getQueryString("token")) {
                  let new_url = common.replaceParamVal(url, "token", token);
                  window.location.href = new_url;
                } else {
                  const new_url = common.addOrgToUrl(url, "token", token);
                  window.location.href = new_url;
                }
              });
            }
          });
          break;
        }
        case 422: {
          const errors = error.response.data.errors;
          let msg = "";
          for (const i in errors) {
            msg += errors[i].join("");
          }
          errorMessage = msg;
          Toast["fail"]({
            message: "（" + error.response.status + "）" + errorMessage,
            duration: 2000
          });
          break;
        }
        default:
          Toast["fail"]({
            message: "（" + error.response.status + "）" + errorMessage,
            duration: 2000
          });
      }
    }

    return Promise.reject(error);
  }
);

export default service;
